import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

export function TextEditor({ value, onChangeHandler }) {
  const editorRef = useRef(null);
  
  return (
    <>
      <Editor
        tinymceScriptSrc="/tinymce/js/tinymce/tinymce.min.js"
        textareaName="content"
        licenseKey="gpl"
        value={value}
        onEditorChange={(newText) => onChangeHandler(newText)}
        onInit={(_evt, editor) => (editorRef.current = editor)}
        init={{
          
          menubar: false,
          branding: false,
          browser_spellcheck: true,
          contextmenu: false,
          plugins: ["lists"],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
        }}
      />
    </>
  );
}
